<template>
  <div>
    <d-card
      :class="['stats-small', computedVariationClass, 'card', 'card-small']"
    >
      <d-card-body :class="[computedBodyClass]">
        <div :class="['d-flex', computedInnerWrapperClass]">
          <div :class="['stats-small__data', computedDataFieldClass]">
            <span
              :class="[
                'stats-small__label',
                'text-uppercase',
                computedLabelClass,
              ]"
            >  
            <b-progress :max="value" show-progress animated v-show="processBar">
              <b-progress-bar variant="success" :value="remainData"> {{remainData}}
              </b-progress-bar>
              <b-progress-bar variant="danger"  :value="usedData"> {{usedData}}   
              </b-progress-bar>
            </b-progress>      
            <br>
              <button
                v-if="btnName != null"
                class="ml-4 btn btn-outline-success btn-sm"
                @click="openModal = true"
              >
                <i :class="[icon]"></i>
              </button>
              <i v-if="btnName == null" :class="[icon]"></i> {{ label }}
            </span>
            <h5
              style="font-weight: bold"
              :class="['count', computedValueClass]"
            >
              {{ value }}
            </h5>
          </div>
        </div>
        <canvas
          :height="computedCanvasHeight"
          ref="canvas"
          :class="[computedChartId]"
        ></canvas>
      </d-card-body>
    </d-card>
    <d-modal v-if="openModal || parentBoolean">
      <d-modal-body>
        <step-form
          :callback="parentBoolean"
          :btnString="btnName"
          :qpStatus="qpayStatus"
          :invoiceCall="false"
          @clicked="onClickChild"
        />
      </d-modal-body>
      <d-modal-footer>
        <d-row>
          <d-col lg="6" md="6" sm="6" v-show="qpayBtn">
            <span>Та төлбөрөө төлсөн бол OK! товчийг дарна уу</span>
          </d-col>
          <d-col lg="3" md="3" sm="3" v-show="qpayBtn">
            <button
              type="link"
              class="btn btn-outline-success"
              @click="onClickQpay()"
            >
              OK
            </button>
          </d-col>
          <d-col lg="3" md="3" sm="3">
            <button
              type="link"
              class="btn btn-outline-info"
              @click="
                  (openModal = false),
                  (parentBoolean = false),
                  (qpayBtn = false),
                  (qpayStatus = '')
              "
            >
              Хаах
            </button>
          </d-col>
        </d-row>
      </d-modal-footer>
    </d-modal>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "../../utils/chart";
import { nanoid } from "../../utils";
import StepForm from "../form/StepFormValidation.vue";

export default {
  name: "d-small-stats",
  components: {
    StepForm,
  },
  props: {
    qpayStatus: { 
      type:String,
      default: ""
    },
    /**
     * The element button.
     */
    parentBoolean: Boolean,

    processBar: Boolean,
    /**
     * The element button.
     */
    btnName: String,
    /**
     * The element Icon.
     */
    icon: {
      type: String,
      required: true,
    },
    /**
     * The element ID.
     */
    id: {
      type: String,
      required: true,
    },
    /**
     * The label.
     */
    label: {
      type: String,
      default: "Label",
    },
    /**
     * The value.
     */
    value: {
      type: [Number, String],
      default: 0,
    },
     /**
     * The usedData.
     */
    usedData: {
      type: [Number, String],
      default: 0,
    },
     /**
     * The remainData.
     */
    remainData: {
      type: [Number, String],
      default: 0,
    },
    /**
     * The percentage number or string.
     */
    percentage: {
      type: [Number, String],
      default: 0,
    },
    /**
     * Whether is a value increase.
     */
    increase: {
      type: Boolean,
      default: true,
    },
    /**
     * Whether is a value decrease.
     */
    decrease: {
      type: Boolean,
      default: false,
    },
    /**
     * The Chart.js options.
     */
    chartOptions: {
      type: Object,
      default() {
        return {};
      },
    },
    /**
     * The chart dataset.
     */
    chartData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    /**
     * The chart configuration. This may override every other setting.
     */
    chartConfig: {
      type: Object,
    },
    /**
     * The variation.
     */
    variation: {
      type: String,
      default: null,
    },
  },
  computed: {
    selectedOption(){
       return this.$store.getters.selected;
    },
    computedChartId() {
      return this.id || `stats-small-${nanoid()}`;
    },
    computedPercentageModifier() {
      return this.increase ? "increase" : "decrease";
    },
    computedVariationClass() {
      return this.variation ? `stats-small--${this.variation}` : null;
    },
    computedBodyClass() {
      if (this.variation === "1") {
        return "p-0 d-flex";
      }

      return "px-0 pb-0";
    },
    computedInnerWrapperClass() {
      if (this.variation === "1") {
        return "flex-column m-auto";
      }

      return "px-3";
    },
    computedDataFieldClass() {
      if (this.variation === "1") {
        return "text-center";
      }

      return null;
    },
    computedLabelClass() {
      if (this.variation === "1") {
        return null;
      }

      return "mb-1";
    },
    computedValueClass() {
      if (this.variation === "1") {
        return "my-3";
      }

      return "m-0";
    },
    computedInnerDataFieldClass() {
      if (this.variation === "1") {
        return null;
      }

      return "text-right align-items-center";
    },
    computedCanvasHeight() {
      if (this.variation === "1") {
        return 120;
      }

      return 60;
    },
  },
  mounted() {
    const chartOptions = {
      ...{
        maintainAspectRatio: true,
        responsive: true,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
          custom: false,
        },
        elements: {
          point: {
            radius: 0,
          },
          line: {
            tension: 0.33,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: false,
              ticks: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: false,
              scaleLabel: false,
              ticks: {
                display: false,
                isplay: false,
                // Avoid getting the graph line cut of at the top of the canvas.
                // Chart.js bug link: https://github.com/chartjs/Chart.js/issues/4790
                suggestedMax: Math.max(...this.chartData[0].data) + 1,
              },
            },
          ],
        },
      },
      ...this.chartOptions,
    };

    const chartConfig = {
      ...{
        type: "line",
        data: {
          ...{
            labels: ["Label 1", "Label 2", "Label 3", "Label 4", "Label 5"],
          },
          ...{
            datasets: this.chartData,
          },
        },
        options: chartOptions,
      },
      ...this.chartConfig,
    };

    new Chart(this.$refs.canvas, chartConfig);
  },
  data() {
    return {
      qpayBtn: false,
      qpayTransactionId: null,
      openModal: false,
    };
  },
  methods: {
    onClickChild(value) {
      if (value != "") {
        this.qpayBtn = true;
        this.qpayTransactionId = value;
      }
      //value from child component
      else this.openModal = value;
    },
    onClickQpay() {       
      const tranconfig = {
        method: "post",
        url:
          "https://www.mongolsat.mn/isat/contract/invoice/check?id=" +
          this.qpayTransactionId +
          "",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.userToken,
        },
      };
      //transaction check by id
      axios(tranconfig).then(
        (response) => {
          if (response.data.code == 0 && response.data.object == true) {
            this.qpayStatus = "success";
            var configData = {
              method: "post",
              url: "https://mongolsat.mn/isat/contract/data",
              headers: {
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPayment = {
              method: "get",
              url: "https://mongolsat.mn/isat/contract/payments?page=1",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPhone = {
                  method: "post",
                  url: "https://www.mongolsat.mn/isat/contract/phones",
                  headers: {
                    Authorization: "Bearer " +  this.$store.getters.userToken,
                  },
                };
            const requestOne = axios(configData);
            const requestTwo = axios(configPayment);
            const requestThirth = axios(configPhone);

            axios.all([requestOne, requestTwo, requestThirth]).then(
              axios.spread((...responses) => {

                  const responseOne = responses[0];
                  const responseTwo = responses[1];
                  const responseThirth = responses[2];

                if (responseOne.data.code == 0 && responseOne.data.object != null) {
                  this.$store.dispatch("retrieveAddData", {
                    addData: responseOne.data.object.topupQuota,
                  });
                  this.$store.dispatch("retrieveRemainData", {
                    remainData: responseOne.data.object.remainingQuota,
                  });
                }
                if (responseTwo.data != null && responseTwo.data.length > 0) {
                  this.$store.dispatch("retrievePayments", {
                    payments: responseTwo.data,
                  });
                }
                if (responseThirth.data.code == 0 && responseThirth.data.object != null) {
                    var tmpPhoneList = [];
                    var i = 0;    
                    
                    for (i = 0; i < responseThirth.data.object.length; i++) {
                        var data = {};
                        data.id = i,
                        data.name = responseThirth.data.object[i].name,
                        data.phone = responseThirth.data.object[i].phone,
                        data.balance = responseThirth.data.object[i].balance < 1 ? 0 : responseThirth.data.object[i].balance,
                        tmpPhoneList.push(data);
                    }
                    this.$store.dispatch("retrievePhoneData", {
                      phoneData: tmpPhoneList,
                    });

                    this.$store.dispatch("retrieveSelected", {
                      selected: tmpPhoneList[this.selectedOption.id],
                    });

                    this.$store.dispatch("retrieveBalance", {
                      balance: responseThirth.data.object[this.selectedOption.id].balance < 1 ? 0 : responseThirth.data.object[this.selectedOption.id].balance,
                    });
                }
              }),
              (error) => {
                console.log(error);
              }
            );
          } else this.qpayStatus = "fail";
          this.qpayBtn = false;
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
};
</script>
